import { datadogRum } from '@datadog/browser-rum'
import { MetricEvent } from './metric-events'

export const setMonitoringUser = (user: { id?: string | number; email?: string; name?: string; username?: string }) => {
  ;(globalThis.window as any).DD_RUM?.setUser(user)
}

export const addError = (error: Error, context: object) => {
  datadogRum.addError(error, context)
}

export const initMonitoring = (params: {
  applicationId: string
  clientToken: string
  service: string
  env: string
  tracking: boolean
  version: string
  getSessionId: () => Promise<string>
}) => {
  if (process.env.NODE_ENV === 'development') return

  datadogRum.init({
    applicationId: params.applicationId,
    clientToken: params.clientToken,
    site: 'datadoghq.eu',
    service: params.service,
    env: params.env,
    sessionSampleRate: 100,
    sessionReplaySampleRate: params.tracking ? 100 : 0,
    trackUserInteractions: params.tracking,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: params.tracking ? 'allow' : 'mask',
    version: params.version,
    beforeSend: (event) => {
      if (
        event?.type === 'error' &&
        (event.error.stack?.includes('@ chrome-extension://') || event.error.stack?.includes('safari-web-extension'))
      ) {
        return false
      }
      return true
    },
  })

  params.getSessionId().then((sessionId) => {
    datadogRum.setGlobalContextProperty('session_id', sessionId)
  })
}

export const instrumentOperation = <T>(action: MetricEvent, performAction: () => T): T => {
  const startTime = performance.now()
  const result = performAction()
  const endTime = performance.now()
  const duration = endTime - startTime
  datadogRum.addAction(action, {
    value: duration,
  })
  return result
}
